<template lang="pug">
.row
  .col-md-12
    .panel.panel-default
      .panel-body
        RollProgressVisualization(:rollInfo="rollInfo" :targetInfo="targetInfo" class="pull-right")
        h2.pull-left(v-if="rollInfo") Roll: {{rollInfo.description}}
        .m20.clearfix
        slot
</template>

<script>
import activationSession from '../service/ActivationSession'
import RollProgressVisualization from './RollProgressVisualization'

export default {
  created() {
    this.refresh()
  },
  data() {
    return {
      rollInfo: null,
      targetInfo: null
    }
  },
  methods: {
    refresh() {
      this.rollInfo = activationSession.getRollInfo()
      this.targetInfo = activationSession.getTargetInfo()
    }
  },
  components: {
    RollProgressVisualization
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/activator/components/RollInfoPanel.vue